import type { Language } from '../../../types/language';
import type { LanguageId } from '../types';

const getExportLanguages = (projectLanguages: Language[], exportLanguages: readonly LanguageId[]) => {
    const ids = new Set(projectLanguages.map(({ id }) => id));

    return exportLanguages.filter((lang) => ids.has(lang));
};

export default getExportLanguages;
